import type { AppSettings } from "../../shared/app-settings.ts";

export type LocalizedMessage = { en: string; ptBR: string };
export type PublicAppStatus = Pick<
  AppSettings,
  | "signupsEnabled"
  | "roomCreationEnabled"
  | "maintenance"
  | "announcement"
  | "defaultParticipantLimit"
  | "maxParticipantLimit"
  | "maxRoomsPerUser"
  | "serverParticipantCap"
  | "screenShareMaxResolution"
  | "screenShareMaxFps"
  | "screenShareMaxBitrateKbps"
>;

export function localizedMessage(message: LocalizedMessage | undefined, locale: string) {
  const primary = locale.toLowerCase().startsWith("pt") ? "ptBR" : "en";
  const secondary = primary === "en" ? "ptBR" : "en";
  return message?.[primary].trim() || message?.[secondary].trim() || "";
}

// Versioned, content-addressed key; changing either translation resurfaces the notice.
export function announcementKey(message: LocalizedMessage) {
  let hash = 0xcbf29ce484222325n;
  for (const char of JSON.stringify([message.en, message.ptBR])) {
    hash = BigInt.asUintN(64, (hash ^ BigInt(char.codePointAt(0)!)) * 0x100000001b3n);
  }
  return `live-room-announcement:v1:${hash.toString(16)}`;
}
